const IMAGE_EXT = /\.(jpe?g|png|webp|gif|bmp|heic|heif)$/i

/** Windows often leaves `file.type` empty for valid images. */
export function isLikelyImageFile(file: File): boolean {
  const type = (file.type || '').toLowerCase()
  if (type.startsWith('image/')) return true
  return IMAGE_EXT.test(file.name)
}
